import { PhraseString } from '../noocoDbTypes';

export const RECTANGULAR_MORPHOLOGY: PhraseString = {
  phraseKey: "APP.PROJECT.SIMULATOR.MORPHOLOGY.RECTANGULAR",
  defaultValue: "Rectangulaire",
  id: 1
};

export type SimExploitationProduction = {
  DIRECT: PhraseString,
  WATER: PhraseString,
};

export type SimParkingTypes = {
  EXTERIOR: PhraseString,
  NONE: PhraseString,
};

export type SimFacadeTechnics = {
  STEEL_WALL: PhraseString,
  CONCRETE_WALL: PhraseString,
  TERRACOTTA: PhraseString,
  CONCRETE_BLOCK: PhraseString,
  WOOD: PhraseString,
  METAL: PhraseString,
  NONE: PhraseString,
};

export type SimFacadeOccultation = {
  FABRIC: PhraseString,
  BLADES: PhraseString,
  NONE: PhraseString,
};

export type SimFacadeGlazing = {
  DOUBLE: PhraseString,
  TRIPLE: PhraseString,
};

export type SimStructureFoundation = {
  TRADITIONNAL: PhraseString,
};

export type SimStructureSlab = {
  CONCRETE: PhraseString,
  CONCRETE_WOOD: PhraseString,
}

export type SimStructureRoof = {
  METAL: PhraseString,
};

export const STRUCTURE_SLAB: SimStructureSlab = {
  CONCRETE: {
    phraseKey: "APP.PROJECT.SIMULATOR.ADVANCED_CONCEPTION.STRUCTURE.SLAB.CONCRETE",
    defaultValue: "Dalle en béton",
    id: 1
  },
  CONCRETE_WOOD: {
    phraseKey: "APP.PROJECT.SIMULATOR.ADVANCED_CONCEPTION.STRUCTURE.SLAB.CONCRETE_WOOD",
    defaultValue: "Dalle en béton/bois",
    id: 2
  }
};

export const PARKING_TYPES: SimParkingTypes = {
  EXTERIOR: {
    phraseKey: "APP.PROJECT.SIMULATOR.QUICK_SIMULATION.PARKINGTYPE.EXTERIOR",
    defaultValue: "Exterieurs",
    id: 1
  },
  NONE: {
    phraseKey: "APP.PROJECT.SIMULATOR.ADVANCED_CONCEPTION.FACADE.OCCULT.NON",
    defaultValue: "Aucun",
    id: 2
  },
};

export const EXPLOITATION_PRODUCTION: SimExploitationProduction = {
  DIRECT: {
    phraseKey: "APP.PROJECT.SIMULATOR.ADVANCED_CONCEPTION.EXPLOITATION.PRODUCTION.DIRECT",
    defaultValue: "Détente directe",
    id: 1
  },
  WATER: {
    phraseKey: "APP.PROJECT.SIMULATOR.ADVANCED_CONCEPTION.EXPLOITATION.PRODUCTION.WATER",
    defaultValue: "Eau glacée",
    id: 2
  }
};

export const FACADE_TECHNICS: SimFacadeTechnics = {
  STEEL_WALL: {
    phraseKey: "APP.PROJECT.SIMULATOR.ADVANCED_CONCEPTION.FACADE.TECH.STEEL_WALL",
    defaultValue: "Mur rideau - Acier",
    id: 1
  },
  CONCRETE_WALL: {
    phraseKey: "APP.PROJECT.SIMULATOR.ADVANCED_CONCEPTION.FACADE.TECH.CONCRETE_WALL",
    defaultValue: "Voile béton",
    id: 2
  },
  TERRACOTTA: {
    phraseKey: "APP.PROJECT.SIMULATOR.ADVANCED_CONCEPTION.FACADE.TECH.TERRACOTTA",
    defaultValue: "Maçonnerie - Terre cuite",
    id: 3
  },
  CONCRETE_BLOCK: {
    phraseKey: "APP.PROJECT.SIMULATOR.ADVANCED_CONCEPTION.FACADE.TECH.CONCRETE_BLOCK",
    defaultValue: "Maçonnerie - Parpaing",
    id: 4
  },
  WOOD: {
    phraseKey: "APP.PROJECT.SIMULATOR.ADVANCED_CONCEPTION.FACADE.TECH.WOOD",
    defaultValue: "Façade - Bois durable",
    id: 5
  },
  METAL: {
    phraseKey: "APP.PROJECT.SIMULATOR.ADVANCED_CONCEPTION.FACADE.TECH.METAL",
    defaultValue: "Façade métal",
    id: 6
  },
  NONE: {
    phraseKey: "APP.PROJECT.SIMULATOR.ADVANCED_CONCEPTION.FACADE.OCCULT.NONE",
    defaultValue: "Aucun",
    id: 7
  },
};

export const FACADE_OCCULTATION: SimFacadeOccultation = {
  FABRIC: {
    phraseKey: "APP.PROJECT.SIMULATOR.ADVANCED_CONCEPTION.FACADE.OCCULT.FABRIC",
    defaultValue: "Store toile",
    id: 1
  },
  BLADES: {
    phraseKey: "APP.PROJECT.SIMULATOR.ADVANCED_CONCEPTION.FACADE.OCCULT.BLADES",
    defaultValue: "Store lames",
    id: 2
  },
  NONE: {
    phraseKey: "APP.PROJECT.SIMULATOR.ADVANCED_CONCEPTION.FACADE.OCCULT.NONE",
    defaultValue: "Aucun",
    id: 3
  },
};

export const FACADE_GLAZING: SimFacadeGlazing = {
  DOUBLE: {
    phraseKey: "APP.PROJECT.SIMULATOR.ADVANCED_CONCEPTION.FACADE.GLAZING.DOUBLE",
    defaultValue: "Double",
    id: 1
  },
  TRIPLE: {
    phraseKey: "APP.PROJECT.SIMULATOR.ADVANCED_CONCEPTION.FACADE.GLAZING.TRIPLE",
    defaultValue: "Triple",
    id: 2
  },
};

export const STRUCTURE_FOUNDATION: SimStructureFoundation = {
  TRADITIONNAL: {
    phraseKey: "APP.PROJECT.SIMULATOR.ADVANCED_CONCEPTION.STRUCTURE.FOUNDATION.TRADITIONNAL",
    defaultValue: "Traditionnelles",
    id: 1
  },
};

export  const STRUCTURE_ROOF: SimStructureRoof = {
  METAL: {
    phraseKey: "APP.PROJECT.SIMULATOR.ADVANCED_CONCEPTION.STRUCTURE.ROOF.METAL",
    defaultValue: "Métal",
    id: 1
  }
};

